import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'id',
        label: i18n.t('attributes.id'),
    },
    {
        key: 'name',
        label: i18n.t('wallets.full_name_account'),
    },
    // {
    //     key: 'sh',
    //     label: i18n.t('wallets.sh'),
    // },
    {
        key: 'balance',
        label: i18n.t('wallets.balance')+'('+i18n.t('rial')+')',
    },
    // {
    //     key: 'removeable_balance',
    //     label: i18n.t('transaction.removeable_balance')+'('+i18n.t('rial')+')',
    // },
    {
        key: 'total_paid_money',
        label: i18n.t('transaction.total_paid_money')+'('+i18n.t('rial')+')',
    },
    {
        key: 'actions',
        label: i18n.t('actions'),
        sorter: false,
        _style: 'width:15%;min-width:150px;',
        _classes: 'text-center align-middle'
    }
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', { attr: i18n.t('attributes.created_at') }),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', { attr: i18n.t('attributes.created_at') }),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.desc', { attr: i18n.t('wallets.balance') }),
        value: {
            direction: 'desc',
            column: 'balance'
        }
    },
    {
        label: i18n.t('sorter.asc', { attr: i18n.t('wallets.balance') }),
        value: {
            direction: 'asc',
            column: 'balance'
        }
    }
]